import { httpClient } from '../http';
import { MutationRequest, NoContent } from '../types';
import {
	AuthUserResponse,
	ChangePasswordRequest,
	LoginRequest,
	LoginResponse,
	RequirePasswordResetRequest,
	SpoofUserResponse,
	StopSpoofResponse,
	UpdatePasswordRequest,
} from './types';

export const login = async ({
	request,
	formKey,
}: MutationRequest<LoginRequest>): Promise<LoginResponse> => {
	const { data } = await httpClient.post<LoginResponse>('/auth/login', request, {
		headers: { formKey },
	});

	return data;
};

export const logout = async (): Promise<NoContent> => {
	const { data } = await httpClient.post<NoContent>('/auth/logout');

	return data;
};

export const sendPasswordResetEmail = async ({
	request,
	formKey,
}: MutationRequest<RequirePasswordResetRequest>): Promise<NoContent> => {
	const { data } = await httpClient.post<NoContent>('/users/password/email', request, {
		headers: { formKey },
	});

	return data;
};

export const sendPasswordUpdateEmail = async (): Promise<NoContent> => {
	const { data } = await httpClient.post<NoContent>('/users/password/token');

	return data;
};

export const updatePassword = async ({
	request,
	formKey,
}: MutationRequest<UpdatePasswordRequest>): Promise<NoContent> => {
	const { data } = await httpClient.post<NoContent>('/users/password/reset', request, {
		headers: { formKey },
	});

	return data;
};

export const getAuthenticatedUser = async (): Promise<AuthUserResponse> => {
	const { data } = await httpClient.get<AuthUserResponse>('/users/me');

	return data;
};

export const spoofUser = async (userId: string): Promise<SpoofUserResponse> => {
	const { data } = await httpClient.post<SpoofUserResponse>(`/auth/spoof/${userId}`);

	return data;
};

export const stopSpoof = async (): Promise<StopSpoofResponse> => {
	const { data } = await httpClient.post<StopSpoofResponse>('/auth/stop-spoof');

	return data;
};

export const changePassword = async (request: ChangePasswordRequest): Promise<NoContent> => {
	const { data } = await httpClient.post<NoContent>('/users/me/password', request);

	return data;
};